/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "risk": {
        "nested": {
          "FraudTaxonomy": {
            "values": {
              "FRAUD_TAXONOMY_UNKNOWN": 0,
              "ATO_FRAUD": 1,
              "ATO_REIMBURSEMENT": 2
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.risk?.nested?.FraudTaxonomy) {
  $root.addJSON(jsonData);
}

/**
 * list of fraud classifications (see https://go.sqprod.co/fraudtaxonomy for details)
 *
 * SOURCE FraudTaxonomy @ squareup/risk-metadata-protos/fraud_taxonomy.proto at 8:1
 */
export const FraudTaxonomy = $root.lookupEnum('squareup.risk.FraudTaxonomy').values;